(function(angular) {
    angular.module('app.activation').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $stateProvider
          .state('activation', {
              url: '/activate',
              templateUrl: '/app/site/activation-flow/activate-user.template.html',
              controller: 'app.activation.ActivateUserController',
              controllerAs: 'vmActivateAccount'
          });
    }]);

})(angular);